import { motion } from 'framer-motion';
import { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

export const Skeleton = memo(({ className, width, height }: SkeletonProps) => {
  return (
    <motion.div
      className={classNames('rounded-full bg-bolt-elements-textPrimary/15 relative overflow-hidden', className)}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
      initial={{ opacity: 0.15 }}
      animate={{ opacity: [0.15, 0.25, 0.15] }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    >
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-bolt-elements-textPrimary/10 to-transparent"
        initial={{ x: '-100%' }}
        animate={{ x: '100%' }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </motion.div>
  );
});
